import PropTypes from 'prop-types';
import Link from 'next/link';
import Chip from '../../Atoms/Chip';

const TopicsFooter = ({ topics = [] }) => {
    if (!topics.length) return null;
    return (
        <div className="topics-footer">
            <div className="text-label text-neutral-600">Explore more on these topics</div>
            <div className="cluster cluster-tight">
                {topics.map((topic) => (
                    <Link key={topic.id} href={topic.url}>
                        <Chip item={topic} variant="static" />
                    </Link>
                ))}
            </div>
        </div>
    );
};

TopicsFooter.propTypes = {
    topics: PropTypes.array,
};

export default TopicsFooter;